// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2uYl8","buttons":"Footer_buttons__2tTZu"};